import React from 'react';

import PropTypes from 'prop-types';

const IconSemFoto = () => (
    <svg
        id='svg'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width='400'
        height='400'
        viewBox='0, 0, 400,400'
    >
        <g id='svgg'>
            <path
                id='path0'
                d=''
                stroke='none'
                fill='#040404'
                fillRule='evenodd'
            />
            <path
                id='path1'
                d=''
                stroke='none'
                fill='#080404'
                fillRule='evenodd'
            />
            <path
                id='path2'
                d=''
                stroke='none'
                fill='#080404'
                fillRule='evenodd'
            />
            <path
                id='path3'
                d=''
                stroke='none'
                fill='#080404'
                fillRule='evenodd'
            />
            <path
                id='path4'
                d=''
                stroke='none'
                fill='#080404'
                fillRule='evenodd'
            />
        </g>
    </svg>
);

IconSemFoto.propTypes = {
    fillColor: PropTypes.string.isRequired
};

export { IconSemFoto };
